// O Supabase/PostgREST limita cada resposta a 1000 linhas (max-rows). Hooks que
// somam TODAS as transações (saldos, dívida de cartão) precisam buscar tudo, senão
// os cálculos ficam truncados/inflados. Este helper pagina via .range() até acabar.
const PAGE_SIZE = 1000

export async function fetchAll<T>(
  makeQuery: (from: number, to: number) => PromiseLike<{ data: T[] | null; error: unknown }>,
): Promise<T[]> {
  const all: T[] = []
  let from = 0
  for (;;) {
    const { data, error } = await makeQuery(from, from + PAGE_SIZE - 1)
    if (error) throw error
    const rows = data ?? []
    all.push(...rows)
    if (rows.length < PAGE_SIZE) break
    from += PAGE_SIZE
  }
  return all
}
